import {Observable, Subject, Subscription} from 'rxjs';

import IErrorsPayload            from '../../Player/Interfaces/IErrorsPayload';
import Player                    from '../../Player/Player';
import getUserDevice             from '../../Shared/Util/getUserDevice';
import Media                     from '../../State/Stores/Media/Media';
import Html5Base                 from '../Shared/Abstract/Html5Base';
import SolutionType              from '../Shared/Constants/SolutionType';
import SyntheticMediaEventType   from '../Shared/Constants/SyntheticMediaEventType';
import IMediaEventsStreamPayload from '../Shared/Interfaces/IMediaEventsStreamPayload';
import ISolutionState            from '../Shared/Interfaces/ISolutionState';
import createMediaEventsStream   from '../Shared/Streams/createMediaEventsStream';
import createVideoElement        from '../Shared/Util/createVideoElement';

import connectSolutionSubscriptions from './connectSolutionSubscriptions';
import createMediaErrorsStream      from './Streams/createMediaErrorsStream';

class Html5 extends Html5Base {
    public type: SolutionType;
    public version: string;
    public mediaEvents$: Observable<IMediaEventsStreamPayload>;
    public mediaErrors$: Observable<IErrorsPayload>;
    public videoElement: HTMLVideoElement;
    protected subscriptions: Subscription[];
    protected syntheticMediaEvents$: Subject<SyntheticMediaEventType>;

    constructor(player: Player, type: SolutionType) {
        super();

        this.type = type;
        this.version = getUserDevice(navigator.userAgent).browserVersion;
        this.videoElement = createVideoElement(player.refs.solution, player.state.stores.volume.value.level);
        this.mediaErrors$ = createMediaErrorsStream(this);
        this.mediaEvents$ = createMediaEventsStream(player.state.stores, this, this.syntheticMediaEvents$);
        this.subscriptions = connectSolutionSubscriptions(player.state.stores, this);
    }

    public get state(): ISolutionState {
        const {currentTime, duration, volume, videoHeight, videoWidth} = this.videoElement;

        return {
            currentTime,
            minTime: 0,
            maxTime: duration,
            resolution: `${videoWidth}x${videoHeight}`,
            volume,
            activeCues: [],
            estimatedBandwidth: -1
        };
    }

    public load(media: Media): void {
        const {src} = media;

        this.videoElement.src = src;

        if (media.startTime > 0) {
            this.seek(media.startTime);
        }

        this.syntheticMediaEvents$.next(SyntheticMediaEventType.READY);
    }

    public async getBitrate(): Promise<number> {
        return 0;
    }

    public setActiveTextTrack(): void {
        super.notImplemented.call(this);
    }
}

export default Html5;